import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './HeaderHome.css';
import logo from '../assets/logo.png';

function HeaderHome() {
  const location = useLocation();
  const isHome = location.pathname === '/'; // Verifica si es la página Home

  return (
    <header className={`header-home ${isHome ? 'header-home-active' : ''}`}>
      {isHome && (
        <div className="header-home-logo">
          <Link to="/">
            <img src={logo} alt="Logo MBZ" />
          </Link>
        </div>
      )}
    </header>
  );
}

export default HeaderHome;
